import { useMemo } from 'react';
import { InterpolatedJnxTemplate } from '../../../util/jnx';
import getPathFromId from '../../../util/getPathFromId';
import classnames from '../../../util/classnames';
import Icon from 'src/components/Icon';
import { useLingui } from '@lingui/react/macro';

type TitleFieldProps = {
  className?: string;
  isSection?: boolean;
  sectionType?: string;
  sectionFromBottom?: boolean;
  id?: string;
  title?: string;
  expandable?: boolean;
  expanded?: boolean;
  bindings?: any;
  toggleExpand?: (e: any) => void;
};

function TitleField({
  className,
  isSection,
  sectionType = 'section',
  sectionFromBottom = false,
  id: $id,
  title: propTitle,
  expandable,
  expanded,
  bindings: propBindings,
  toggleExpand,
}: TitleFieldProps) {
  const {
    i18n: { locale },
  } = useLingui();

  const index = useMemo(
    () =>
      +(
        ($id ?? '')
          .split('_')
          .filter(x => /^[0-9]+$/.test(x))
          .pop() ?? '0'
      ) | 0,
    [$id]
  );

  const bindings = useMemo(
    () => ({
      index,
      locale,
      ...propBindings,
    }),
    [index, propBindings]
  );

  const path = useMemo(() => getPathFromId($id || ''), [$id]);

  const title = useMemo(() => {
    if (!propTitle) return '';
    const tpl = new InterpolatedJnxTemplate(propTitle, '.');
    return tpl.eval(bindings.rootFormData || {}, path, bindings, false);
  }, [propTitle, bindings, path]);

  return title ? (
    <legend
      id={title ? `${$id}__title${isSection ? '' : '_ns'}` : ''}
      className={classnames(`type-${sectionType} form-subtitle`, className, { 'bottom-section': sectionFromBottom })}
      style={{ cursor: expandable ? 'pointer' : 'default' }}
      onClick={expandable ? toggleExpand : undefined}
    >
      {title}
      {expandable ? (
        <Icon icon={classnames('fa-caret-up animate-transform', { rotate180: !expanded })} style={{ marginLeft: 8, fontSize: 14 }} />
      ) : null}
    </legend>
  ) : null;
}

export default TitleField;
